import React from "react";

interface StartDateCellProps {
  row: {
    start?: Date;
    end?: Date;
  };
}

const formatDate = (value?: Date): string => {
  if (!value) return "";
  const dt = new Date(value as any);
  return isNaN(dt.getTime()) ? "" : dt.toLocaleDateString("en-GB").replace(/\//g, ".");
};

const isSameCalendarDate = (a?: Date, b?: Date): boolean => {
  if (!a || !b) return false;
  const da = new Date(a as any);
  const db = new Date(b as any);
  return da.getFullYear() === db.getFullYear() && da.getMonth() === db.getMonth() && da.getDate() === db.getDate();
};

const StartDateCell: React.FC<StartDateCellProps> = ({ row }) => {
  const { start, end } = row || {};

  if (!start) return <span></span>;

  // Hide start date if it's the same as the end date (milestone)
  if (end && isSameCalendarDate(start, end)) {
    return <span></span>;
  }

  return <span>{formatDate(start)}</span>;
};

export default StartDateCell;
